/** Marks a contribution text element - the localised string, the contributions count or the date */
export var ContributionCountElement;
(function (ContributionCountElement) {
    /** The localised string */
    ContributionCountElement[ContributionCountElement["TEXT"] = 0] = "TEXT";
    /** The contributions count */
    ContributionCountElement[ContributionCountElement["COUNT"] = 1] = "COUNT";
    /** The date */
    ContributionCountElement[ContributionCountElement["DATE"] = 2] = "DATE";
})(ContributionCountElement || (ContributionCountElement = {}));
Object.freeze(ContributionCountElement);



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/Translate/types/ContributionCountElement.ts
// module id = 4
// module chunks = 0 1